module.exports = __webpack_public_path__ + "static/media/certificate_icon.0601e89b.svg";